import type { IconProps } from "@/types/IconProps";

export function Email(props: IconProps) {
  const { size = 24, className, color = "currentColor", ...svgProps } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill={color}
      viewBox="0 0 24 24"
      className={className}
      {...svgProps}
    >
      <path d="M22.5 12c0-5.799-4.701-10.5-10.5-10.5S1.5 6.201 1.5 12 6.201 22.5 12 22.5V24C5.373 24 0 18.627 0 12S5.373 0 12 0s12 5.373 12 12-5.373 12-12 12v-1.5c5.799 0 10.5-4.701 10.5-10.5"></path>
      <path d="m17.084 10.45-4.092 2.607-.027.016a1.92 1.92 0 0 1-1.95-.016l-4.098-2.609V15.5c0 .23.187.416.417.416h9.333c.23 0 .416-.186.417-.416zm-9.75-2.367a.417.417 0 0 0-.417.417v.171l4.879 3.106a.42.42 0 0 0 .41 0l4.878-3.106v-.17a.417.417 0 0 0-.417-.418zm11.25 7.417a1.917 1.917 0 0 1-1.917 1.916H7.334A1.917 1.917 0 0 1 5.417 15.5v-7c0-1.058.858-1.917 1.917-1.917h9.333c1.058 0 1.917.859 1.917 1.917z"></path>
    </svg>
  );
}
